import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'booleanToActive'
})
export class BooleanToActive implements PipeTransform {

  transform(value: boolean | null | undefined): string {
    if (value === true) {
      return 'Active';
    } else if (value === false) {
      return 'Suspended';
    }
    return ''; // Handle null or undefined values
  }

}
